import { createEntityAdapter } from '@ngrx/entity';
import { CaracteristiqueChoixTemplateEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<CaracteristiqueChoixTemplateEntityState>;

export const adapter = createEntityAdapter<CaracteristiqueChoixTemplateEntityState>({
  selectId: o => o.idCaracteristiqueChoixTemplate
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const caracteristiqueChoixTemplateFeatureKey = 'caracteristiqueChoixTemplate';
